import { postCreateCodeCountry } from '../api/postCreateCodeCountry';

const setPostCreateCodeCountry = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCreateCodeCountry(params);
            window.location.replace('/settings/code_country/list')
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateCodeCountry
}